const treatments = [
  {
    tag: 'Classic',
    name: 'Braces',
    desc: 'Time-tested precision. Metal and clear bracket options tailored to every age and case complexity.',
    img: 'https://public.readdy.ai/ai/img_res/d5b3ef5d0d418d2b273a215406fbec54.jpg',
    link: 'https://smilebydrkortez.com/braces',
    large: true,
  },
  {
    tag: 'Discreet',
    name: 'InBrace',
    desc: 'Hidden behind your teeth. No visible wires — just effortless, discreet transformation.',
    img: 'https://readdy.ai/api/search-image?query=Confident%20stylish%20young%20professional%20woman%20smiling%20warmly%20with%20perfect%20teeth%20in%20bright%20sunlit%20setting%2C%20clean%20warm%20cream%20background%20with%20soft%20diffused%20natural%20light%2C%20polished%20high-end%20lifestyle%20photography%2C%20sophisticated%20healthcare%20aesthetic%2C%20upscale%20editorial%20quality%20portrait%2C%20warm%20golden%20tones&width=540&height=500&seq=tx02inbracev4&orientation=landscape',
    link: 'https://smilebydrkortez.com/inbrace',
    large: false,
  },
  {
    tag: 'Corrective',
    name: 'Bite Correction',
    desc: 'Precision care for overbite, underbite, and crossbite — restoring function and aesthetic harmony.',
    img: 'https://readdy.ai/api/search-image?query=Happy%20relaxed%20patient%20in%20a%20modern%20premium%20orthodontic%20consultation%20room%20smiling%20with%20confidence%2C%20bright%20clean%20clinical%20setting%20with%20warm%20natural%20light%2C%20premium%20healthcare%20environment%2C%20soft%20warm%20ivory%20tones%2C%20minimal%20elegant%20medical%20spa%20aesthetic%2C%20professional%20attentive%20care%20setting%2C%20photorealistic%20quality&width=540&height=500&seq=tx03bitev4&orientation=landscape',
    link: 'https://smilebydrkortez.com/bite-correction',
    large: false,
  },
  {
    tag: 'Alignment',
    name: 'Teeth Straightening',
    desc: 'From mild crowding to complex alignment, we design a personalized path to beautifully straight teeth.',
    img: 'https://readdy.ai/api/search-image?query=Joyful%20teenager%20with%20a%20radiant%20wide%20bright%20smile%20and%20straight%20white%20teeth%20in%20warm%20natural%20outdoor%20setting%2C%20golden%20afternoon%20light%2C%20clean%20fresh%20editorial%20portrait%2C%20warm%20soft%20cream%20tones%2C%20premium%20orthodontic%20lifestyle%20photography%2C%20healthy%20glowing%20skin%2C%20upscale%20healthcare%20branding%2C%20photorealistic%20quality&width=640&height=780&seq=tx04straightv4&orientation=portrait',
    link: 'https://smilebydrkortez.com/teeth-straightening',
    large: true,
  },
];

export default function TreatmentsSection() {
  return (
    <section id="services" className="bg-[#F7F6F3] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-8 h-px bg-[#C4A96E]" />
              <span
                className="text-[#C4A96E] text-[10px] tracking-[0.32em] uppercase font-semibold"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Featured Treatments
              </span>
            </div>
            <h2
              className="text-[42px] md:text-[54px] text-[#1A2118] font-semibold leading-[1.06]"
              style={{ fontFamily: 'Cormorant Garamond, serif', letterSpacing: '-0.015em' }}
            >
              The Right Path<br />
              <span className="font-light italic text-[#4C8265]">for Every Smile</span>
            </h2>
          </div>
          <a
            href="https://smilebydrkortez.com/treatments"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 text-[#1A2118] font-medium text-sm whitespace-nowrap cursor-pointer self-start md:self-auto group"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            <span className="border-b border-[#1A2118]/30 group-hover:border-[#1A2118] transition-colors pb-0.5">
              View All Treatments
            </span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200" />
          </a>
        </div>

        {/* Magazine asymmetric grid: large | two stacked | large */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Large card — Braces */}
          <a
            href={treatments[0].link}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-[20px] overflow-hidden cursor-pointer block lg:row-span-2"
            style={{ height: '480px' }}
          >
            <img
              src={treatments[0].img}
              alt={`${treatments[0].name} – Smile By Dr. K Orthodontics`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F1E16]/88 via-[#0F1E16]/25 to-transparent" />
            <div className="absolute top-5 left-5">
              <span
                className="bg-[#C4A96E] text-white text-[9px] tracking-[0.2em] uppercase font-bold px-3 py-1.5 rounded-full"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {treatments[0].tag}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h3
                className="text-white font-semibold text-3xl mb-2"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                {treatments[0].name}
              </h3>
              <p
                className="text-white/60 text-xs leading-relaxed mb-4"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {treatments[0].desc}
              </p>
              <div className="flex items-center gap-1.5 text-[#C4A96E] text-xs font-semibold">
                <span style={{ fontFamily: 'DM Sans, sans-serif' }}>Learn More</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200" />
              </div>
            </div>
          </a>

          {/* Two stacked medium cards */}
          <div className="lg:col-span-2 grid grid-rows-2 gap-4" style={{ height: '480px' }}>
            {treatments.slice(1, 3).map((t) => (
              <a
                key={t.name}
                href={t.link}
                target="_blank"
                rel="noopener nofollow"
                className="group relative rounded-[20px] overflow-hidden cursor-pointer block"
              >
                <img
                  src={t.img}
                  alt={`${t.name} – Smile By Dr. K`}
                  className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#0F1E16]/80 via-[#0F1E16]/40 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                  <span
                    className="text-[#C4A96E] text-[9px] tracking-[0.2em] uppercase font-bold mb-1.5"
                    style={{ fontFamily: 'DM Sans, sans-serif' }}
                  >
                    {t.tag}
                  </span>
                  <h3
                    className="text-white font-semibold text-xl md:text-2xl mb-1.5"
                    style={{ fontFamily: 'Cormorant Garamond, serif' }}
                  >
                    {t.name}
                  </h3>
                  <p
                    className="text-white/55 text-xs leading-relaxed hidden sm:block"
                    style={{ fontFamily: 'DM Sans, sans-serif' }}
                  >
                    {t.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>

          {/* Large card — Teeth Straightening */}
          <a
            href={treatments[3].link}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-[20px] overflow-hidden cursor-pointer block lg:row-span-2"
            style={{ height: '480px' }}
          >
            <img
              src={treatments[3].img}
              alt={`${treatments[3].name} – Smile By Dr. K Orthodontics`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F1E16]/88 via-[#0F1E16]/25 to-transparent" />
            <div className="absolute top-5 left-5">
              <span
                className="bg-[#4C8265] text-white text-[9px] tracking-[0.2em] uppercase font-bold px-3 py-1.5 rounded-full"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {treatments[3].tag}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h3
                className="text-white font-semibold text-3xl mb-2"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                {treatments[3].name}
              </h3>
              <p
                className="text-white/60 text-xs leading-relaxed mb-4"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {treatments[3].desc}
              </p>
              <div className="flex items-center gap-1.5 text-[#4C8265] text-xs font-semibold">
                <span style={{ fontFamily: 'DM Sans, sans-serif' }}>Learn More</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200" />
              </div>
            </div>
          </a>
        </div>

      </div>
    </section>
  );
}
